import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ClientProtectedRoute = ({ children }) => {
  const { user, loading, isClient } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (user && isClient()) {
    return children;
  }

  return <Navigate to="/login" state={{ from: location }} replace />;
};

export default ClientProtectedRoute;
